import React from "react";

import MainLayout from "../components/MainLayout";
import Hero from "./home/container/Hero";


const AboutPage = () => {

    return <MainLayout>
        <div className="flex flex-col h-screen">
            <Hero />
        </div>
    </MainLayout>
}; 

export default AboutPage; 